import { render, staticRenderFns } from "./BaseInfoModal.vue?vue&type=template&id=b7f02398&"
import script from "./BaseInfoModal.vue?vue&type=script&lang=js&"
export * from "./BaseInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports